export { default } from '@/themes/kultour/components/template/footer/FooterTrustLogos'
